export default __webpack_public_path__ + "static/media/funds.27634eba.svg";